import { apiUrl } from "../constants/global";
import i18n from "../i18n";
import { getLoggedUser } from "../state/user";
import axios from "axios";
const user = getLoggedUser();

const statuses = {
  N: i18n.t("new"),
  P: i18n.t("pending"),
  C: i18n.t("completed"),
};

async function createMeeting(payload) {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      apiUrl + "meetings",
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function getAllMeetings(q) {
  return fetch(apiUrl + "meetings?" + q, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  }).then((data) => data.json());
}

async function getMeeting(id) {
  return fetch(apiUrl + "meetings/" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  }).then((data) => data.json());
}

async function updateMeeting(payload, id) {
  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      apiUrl + "meetings/" + id,
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function deleteMeeting(payload) {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      apiUrl + "delete_meeting",
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function getMeetingAttendees(meeting) {
  return fetch(`${apiUrl}get_attendees/${meeting}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  }).then((data) => data.json());
}

async function createMeetingAttendees(payload) {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      apiUrl + "create_attendee",
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function updateMeetingAttendees(payload) {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      apiUrl + "update_attendee",
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function deleteMeetingAttendee(payload) {
  let config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      apiUrl + "delete_attendee",
      payload,
      config
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

export {
  createMeeting,
  getAllMeetings,
  getMeeting,
  updateMeeting,
  deleteMeeting,
  getMeetingAttendees,
  createMeetingAttendees,
  updateMeetingAttendees,
  deleteMeetingAttendee,
  statuses,
};
